/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ProfileChangeEvent} from '../models/ProfileChangeEvent';
import type {ProfileChangeHistory} from '../models/ProfileChangeHistory';

export interface GetProfileChangeEvent$Request {
    profileId: number;
    eventId: number;
}

export interface GetProfileChangeEvent$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProfileChangeEventRequest = createAction<PayloadData<void, GetProfileChangeEvent$Request>>('PROFILE_CHANGE_HISTORY__GET_PROFILE_CHANGE_EVENT__REQUEST');
export const getProfileChangeEventSuccess = createAction<PayloadData<ProfileChangeEvent, GetProfileChangeEvent$Request>>('PROFILE_CHANGE_HISTORY__GET_PROFILE_CHANGE_EVENT__SUCCESS');
export const getProfileChangeEventFailure = createAction<PayloadData<Error, GetProfileChangeEvent$Request, true>>('PROFILE_CHANGE_HISTORY__GET_PROFILE_CHANGE_EVENT__FAILURE');

export const getProfileChangeEventActions = [
    getProfileChangeEventRequest,
    getProfileChangeEventSuccess,
    getProfileChangeEventFailure
] as const;

/**
 * @param {number} meta.profileId
 * @param {number} meta.eventId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProfileChangeEvent = (meta: GetProfileChangeEvent$Request, config?: GetProfileChangeEvent$Config) => {
    return {
        CALL_API: {
            types: getProfileChangeEventActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/admins/profiles/${meta.profileId}/audit-logs/${meta.eventId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProfileChangeHistory$Request {
    profileId: number;
    pageNumber?: number;
    pageSize?: number;
}

export interface GetProfileChangeHistory$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProfileChangeHistoryRequest = createAction<PayloadData<void, GetProfileChangeHistory$Request>>('PROFILE_CHANGE_HISTORY__GET_PROFILE_CHANGE_HISTORY__REQUEST');
export const getProfileChangeHistorySuccess = createAction<PayloadData<ProfileChangeHistory, GetProfileChangeHistory$Request>>('PROFILE_CHANGE_HISTORY__GET_PROFILE_CHANGE_HISTORY__SUCCESS');
export const getProfileChangeHistoryFailure = createAction<PayloadData<Error, GetProfileChangeHistory$Request, true>>('PROFILE_CHANGE_HISTORY__GET_PROFILE_CHANGE_HISTORY__FAILURE');

export const getProfileChangeHistoryActions = [
    getProfileChangeHistoryRequest,
    getProfileChangeHistorySuccess,
    getProfileChangeHistoryFailure
] as const;

/**
 * @param {number} meta.profileId
 * @param {number} [meta.pageNumber]
 * @param {number} [meta.pageSize]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProfileChangeHistory = (meta: GetProfileChangeHistory$Request, config?: GetProfileChangeHistory$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
    };
    return {
        CALL_API: {
            types: getProfileChangeHistoryActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/admins/profiles/${meta.profileId}/audit-logs`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

